module.exports = __webpack_public_path__ + "static/media/MFEQUL.18de99e4.png";